export enum ProfileEstimatedDeliveryDateTypeEnum {
  Auto = 'AUTO',
  Lsp = 'LSP',
  Calculated = 'CALCULATED',
  Ai = 'AI',
}
